import React from 'react';
import Form from './Form';
import client1 from "../images/upes_logo.png"
import client2 from "../images/Bennett-University-logo.png"
import client3 from "../images/uttaranchal-logo.jpg"
import client4 from "../images/devbhomi-logo.png"
import client5 from "../images/dbs-logo.png"
import client6 from "../images/mayadevi-logo.png"
import client7 from "../images/BFIT.webp"
import client8 from "../images/shivaliklogo.png"
import client9 from "../images/alpinelogo.png"
import client10 from "../images/gnc.png"
import counciler from "../images/councling.jpg"
import { useState } from 'react';
import EnquiryFormPopup from './EnquiryFormPopup';
const Home = () => {
  //  const [showPopup, setShowPopup] = useState(true);

  // const handleFormSubmit = () => {
  //   setShowPopup(false);
  // };
   const [showPopup, setShowPopup] = useState(true);

  const handleFormSubmit = () => {
    setShowPopup(false);
  };
  return (
    <>
      {/* Hero Section */}
       {showPopup && <EnquiryFormPopup onSubmit={handleFormSubmit} />}
      <div style={{ filter: showPopup ? 'blur(3px)' : 'none' }}></div>
      <section className="hero-section d-flex align-items-center">
  <div className="container">
    <div className="row align-items-center hero-blur-box">
      
      {/* Left Column: Text */}
      <div className="col-md-7 text-md-start text-center">
        <small className="text-uppercase text-warning fw-semibold">Career Guidance & Support</small>
        <h1 className="fw-bold mt-2">Your Career, Your Future</h1>
        <p className="text-light mt-3">
          Your career shapes your identity and future. Choosing the right path is about discovering your passion, understanding your strengths, and finding opportunities that align with them.
          <br /><br />
          With expert counseling, personalized tools, and up-to-date resources, we help you explore academic options, career fields, and skill-building avenues. Whether you're a student or a graduate, we're here to guide you.
        </p>

        <div className="mt-4 d-flex justify-content-md-start justify-content-center gap-3 flex-wrap">
        <button className="btn btn-purple rounded-pill  p-3 px-4" data-bs-toggle="modal" data-bs-target="#counselingModal">
  Apply for a Session
</button>
        </div>

        {/* Stats */}
        <div className="d-flex align-items-center gap-4 mt-4 justify-content-md-start justify-content-center">
          <div>
            <h5 className="text-white mb-0">1000+</h5>
            <small className="text-light">Students Guided</small>
          </div>
          <div>
            <h5 className="text-white mb-0">95%</h5>
            <small className="text-light">Success Rate</small>
          </div>
        </div>
      </div>

      {/* Right Column: Image */}
      <div className="col-md-5 text-start mt-4 mt-md-0">
        <Form />
      </div>
    </div>
  </div>
</section>

      {/* News Section */}
      <section className="py-5">
  <div className="container">
    <div className="row justify-content-center g-4">
      {[
        { title: 'University of Petroleum and Energy Studies, Dehradun', logo: client1 },
        { title: 'Bennett University', logo: client2 },
        { title: 'Uttaranchal University Dehradun', logo: client3 },
        { title: 'Dev Bhoomi Uttarakhand University', logo: client4 },
        { title: 'Doon Business School, Dehradun', logo: client5 },
        { title: 'Maya Devi University, Dehradun', logo: client6 },
        { title: 'BFIT College, Dehradun', logo: client7 },
        { title: 'SHIVALIK College, Dehradun', logo: client8 },
        { title: 'Alpine Group Of Institutes Dehradun', logo: client9 },
        { title: 'Guru Nanak College, Dehradun', logo: client10 },
      ].map((item, index) => (
        <div className="col-md-3" key={index}>
          <div className="card h-100">
            <div className="card-body text-center">
              <img
                src={item.logo}
                alt="Logo"
                style={{ height: '40px', marginBottom: '10px', objectFit: 'contain' }}
              />
              <small className="text-purple d-block">{item.title}</small>
              <small className="text-muted">{item.time}</small>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* Counselling Section */}
      <section className="py-5 bg-white text-center">
  <div className="container">
    <h2 className="fw-bold text-dark">Counseling</h2>
    <p className="text-muted">
      We help you through personalized counseling sessions to find the right career path,
      type of course & colleges according to your profile.
    </p>

    <div className="row align-items-center justify-content-center mt-5">
      {/* Image on the left */}
      <div className="col-md-6 mb-4 mb-md-0">
        <img
          src={counciler}
          alt="Graduation"
          className="img-fluid rounded shadow"
          width={"70%"}
        />
      </div>

      {/* Cards on the right */}
      <div className="col-md-6">
        <div className="card mb-4 shadow-sm border-0">
          <div className="card-body text-start">
            <h5 className="text-purple fw-semibold">Expert Counseling</h5>
            <p className="text-muted">
              Get personalized guidance from our expert counselors to help you make informed decisions about your academic and career path.
            </p>
            <button className="btn btn-purple rounded-pill" data-bs-toggle="modal" data-bs-target="#counselingModal">
  Apply for a Session
</button>
          </div>
        </div>

        <div className="card shadow-sm border-0">
          <div className="card-body text-start">
            <h5 className="text-purple fw-semibold">Q&A</h5>
            <p className="text-muted">
              Ask questions and get answers from our community of experts and students.
              Clarify your doubts about colleges, exams, and more.
            </p>
            <button className="btn btn-purple rounded-pill" data-bs-toggle="modal" data-bs-target="#counselingModal">
  Ask a Question
</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
{/* Modal */}
<div
  className="modal fade"
  id="counselingModal"
  tabIndex="-1"
  aria-labelledby="counselingModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title text-purple" id="counselingModalLabel">ENQUIRE NOW</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <Form/>
      </div>
    </div>
  </div>
</div>







<section className="py-5" style={{ backgroundColor: "#f9fafc" }}>
  <div className="container text-center">
    <h2 className="fw-bold text-dark">Data</h2>
    <p className="text-muted">
      Explore our comprehensive database of rankings, exams, and more to make informed decisions.
    </p>

    <div className="row justify-content-center mt-4">
      {/* Rankings Card */}
      <div className="col-md-5 mb-4">
        <div className="p-4 bg-white rounded shadow-sm text-start">
          <h5 className="fw-bold text-purple mb-3">Rankings</h5>
          <ul className="list-unstyled">
            {[
              "Top Law Colleges in India",
              "Top MBA Colleges in India",
              "Top Engineering Colleges in India",
              "Top Medical Colleges in India",
              "Top Science Colleges in India",
              "Top Design Colleges in India",
            ].map((item, index) => (
              <li key={index} className="mb-2">
                <span className="text-purple me-2">➜</span>
                <a href="/" className="text-purple text-decoration-none">{item}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Exams Card */}
      <div className="col-md-5 mb-4">
        <div className="p-4 bg-white rounded shadow-sm text-start">
          <h5 className="fw-bold text-purple mb-3">Exams</h5>
          <ul className="list-unstyled">
            {["JEE Main", "NEET", "GATE", "CAT", "CLAT", "UPSC"].map((exam, index) => (
              <li key={index} className="mb-2">
                <span className="text-purple me-2">➜</span>
                <a href="/" className="text-purple text-decoration-none">{exam}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Online Courses Section */}
      <section className="py-5" style={{ backgroundColor: "#f9fafc" }}>
  <div className="container text-center">
    <h2 className="fw-bold text-dark">Online Courses and Certifications</h2>
    <p className="text-muted">
      Learn new skills and advance your career with our online courses and certifications.
    </p>

    <div className="row justify-content-center mt-5">
      {/* Trending Specializations */}
      <div className="col-md-5 mb-4">
        <div className="p-4 bg-white rounded-4 shadow-sm text-start border border-light-subtle">
          <h5 className="fw-bold text-purple mb-3">Trending Specializations</h5>
          <div className="d-flex flex-wrap gap-2">
            {[
              "Digital Marketing", "Cyber Security", "Data Analytics", "Machine Learning",
              "Cloud Computing", "UI/UX Design", "Project Management", "Blockchain",
              "AI & Robotics", "Full Stack Development", "IoT"
            ].map((item, index) => (
              <span key={index} className="badge bg-light-purple text-purple fw-semibold px-3 py-2 rounded-pill">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Trending Courses */}
      <div className="col-md-5 mb-4">
        <div className="p-4 bg-white rounded-4 shadow-sm text-start border border-light-subtle">
          <h5 className="fw-bold text-purple mb-3">Trending Courses</h5>
          <div className="d-flex flex-wrap gap-2">
            {[
              "Python Programming", "Web Development", "Data Science", "Digital Marketing",
              "UX Design", "Business Analytics", "Artificial Intelligence", "Financial Management",
              "Mobile App Development", "Content Writing"
            ].map((course, index) => (
              <span key={index} className="badge bg-light-purple text-purple fw-semibold px-3 py-2 rounded-pill">
                {course}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="py-5 text-center">
  <div className="container">
    <h2 className="fw-bold text-dark">Other Products</h2>
    <p className="text-muted mb-5">
      Explore our other tools and resources to help you make the best decisions for your educational journey.
    </p>

    <div className="row justify-content-center">
      {[
        { icon: "fa-building-columns", title: "College Compare", desc: "Compare colleges side by side" },
        { icon: "fa-square-check", title: "College Reviews", desc: "Read authentic student reviews" },
        { icon: "fa-graduation-cap", title: "B.Tech Companion", desc: "Your guide through engineering" },
        { icon: "fa-book-open", title: "NEET Companion", desc: "Your guide to medical admissions" },
      ].map((item, index) => (
        <div key={index} className="col-6 col-md-3 mb-4">
          <div className="d-flex flex-column align-items-center">
            <div className="bg-light-purple rounded-circle d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
              <i className={`fas ${item.icon} fa-lg text-purple`}></i>
            </div>
            <h6 className="fw-bold text-purple mb-1">{item.title}</h6>
            <p className="text-muted small">{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
<footer className="footer text-light py-5">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <h6 className="footer-heading">Top Exams</h6>
            <ul className="list-unstyled footer-links">
              <li>JEE Main</li>
              <li>NEET</li>
              <li>GATE</li>
              <li>CAT</li>
            </ul>
          </div>
          <div className="col-md-4 mb-4">
            <h6 className="footer-heading">Colleges</h6>
            <ul className="list-unstyled footer-links">
              <li>Engineering</li>
              <li>Medical</li>
              <li>MBA</li>
              <li>Law</li>
            </ul>
          </div>
          <div className="col-md-4 mb-4">
            <h6 className="footer-heading">Company</h6>
            <ul className="list-unstyled footer-links">
              <li>About Us</li>
              <li>Contact Us</li>
              <li>Terms of Use</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="footer-logo mb-3 mb-md-0">
            <span className="brand-light">UTTARAKNAND</span> <span className="brand-bold">UNIVERSITIES</span>
          </div>
          <p className="mb-3 mb-md-0 text-muted">© 2025 UTTARAKNAND UNIVERSITIES. All rights reserved.</p>
         
        </div>
      </div>
    </footer>


    </>
  );
};

export default Home;
